import { render, staticRenderFns } from "./CompClaimModal.vue?vue&type=template&id=2243a741"
import script from "./CompClaimModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompClaimModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports